module.exports = __webpack_public_path__ + "static/media/TurquoiseClaims_logo_final.2ecfb74d.png";